// src/stores/crmStore.js
import { makeAutoObservable } from "mobx";
import SalesforceImg from "../../../../Assets/CRM/salesforce.png";
import HubspotImg from "../../../../Assets/CRM/Hubspot.png";
import ZohoImg from "../../../../Assets/CRM/zoho.png";
import { commonAxios } from "../../CommonAxios";
import { runInAction } from "mobx";
import { reaction } from "mobx";
import { toJS } from "mobx";
import { showAlertToast } from "../../../../Components/ToastComponent/AlertMessage.js";
class CRMStore {
  rootStore;
  integrations = [];
  commonCRMmapper = new Map();
  hoveringMap = new Map();
  fieldsList = [];
  mandatoryFields=[];
  crmlabledata = [];
  fieldMappings = {};
  searchQuery = "";
  searchForFieldMapping="";
  crmJsonData=[];
 selectedOption = "Create NewRecords";
   isHovering = false;
    selectedCrm = null;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    this.loadIntegrations();
    this.commonCRMmapper.set("getTabIndex", 0);
    this.commonCRMmapper.set('fieldMappingModalOpen', false);
    this.commonCRMmapper.set('isConnectedCrm',[])
    this.commonCRMmapper.set('defaultCRM',null)
    reaction(
      () => this.commonCRMmapper.get("activeTab"),
      (tab) => {
        this.getEnrichmentFieldApi(tab,localStorage.getItem('crmName'));
        // this.getOptions(tab);
        this.restoreFieldMapping(tab);
        this.fieldMappings={}
      }
    );
  }
    setHovering(state) {
    this.isHovering = state;
  }
  setMapping(fieldKey, selectedOption) {
    const plainOption = toJS(selectedOption);
    this.fieldMappings[fieldKey.fields] = {
      fieldKey: fieldKey.fields,
      fieldLabel: fieldKey.label,
      selectedValue: plainOption,
    };
  }
  getPayload() {
  console.log(toJS(this.fieldMappings), "mappinglaks");
  return Object.entries(this.fieldMappings)
    .filter(
      ([key, value]) =>
        key !== "undefined" &&
        value.fieldKey &&
        value.fieldLabel &&
        value.selectedValue !== null
    )
    .map(([fieldKey, crmKey]) => ({
      columnKey: crmKey.fieldKey,   // e.g., "HQ Town"
      columnName: crmKey.fieldLabel, // e.g., "HQTown"
      crmKey: crmKey.selectedValue, // e.g., "address"
    }));
}

  setSearchQuery(query) {
    this.searchQuery = query;
  }
  setSearchForFieldMapping(quary) {
    this.searchForFieldMapping= quary;  
  }
  get filteredIntegrations() {
    return this.integrations.filter((element) =>
      element.crmType.includes(this.searchQuery.toLowerCase())
    );
  }
   setHovering(crmName, value) {
    this.hoveringMap.set(crmName, value);
  }

   setSelectedCrm(data) {
    this.selectedCrm = data;
  }

  getSelectedCrm() {
    return this.selectedCrm;
  }
  isHover(crmName) {
    return this.hoveringMap.get(crmName) || false;
  }
  loadIntegrations() {
    // this.integrations = [
    //   {
    //     image: HubspotImg,
    //     header: "Hubspot",
    //     slogan:
    //       "Hubspot CRM integrates wth various tools to streamline sales, marketing and customer service for improved efficiency",
    //   },
    //   {
    //     image: SalesforceImg,
    //     header: "Salesforce",
    //     slogan:
    //       "Cloud-based software designed to help business find more products , close more deals with customers",
    //   },
    //   {
    //     image: ZohoImg,
    //     header: "Zoho",
    //     slogan:
    //       "Zoho CRM integrates with various tools to streamline workflows, enrich productivity, and improve customer",
    //   },
    // ];
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonCRMmapper.set(key, value);
      }
    });
  }
  closeModal = () => {
    this.applyTheValue({ isModalOpen: false });
  };
  addIntegration(integration) {
    this.integrations.push(integration);
  }
  get getModalIsOpen() {
    return this.commonCRMmapper.get("isModalOpen") || false;
  }
  get getFieldMappingModal() {
    return this.commonCRMmapper.get("fieldMappingModalOpen");
  }
  setOption = (value) => {
    this.selectedOption = value;
  };
  // Usage example
  // handleConnect = async () => {
  //   try {
  //     this.rootStore.callCommonLoader(true);
  //     const crmName = localStorage.getItem("crmName");
  //     const response = await commonAxios(
  //       `/${crmName}`,
  //       "GET",
  //       {},
  //       {
  //         crm: crmName,
  //       }
  //     );
  //     if (response.data.redirectUrl) {
  //       window.location.href = response.data.redirectUrl;
  //     }
  //   } catch (error) {
  //   } finally {
  //     this.rootStore.callCommonLoader(false);
  //   }
  // };
   handleConnect = async () => {
    try {
      this.rootStore.callCommonLoader(true);
      const crmName = localStorage.getItem("crmName");
      const response = await commonAxios(
        `/crm/connect`,
        "GET",
        {},
        {
          crm: crmName,
        }
      );
      if (response.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
      }
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };
  verifyAuth = async () => {
    // Restore crmName from localStorage
    const crmName = localStorage.getItem("crmName");
    if (!crmName) {
      return;
    }
    const code = this.commonCRMmapper.get("code");
    const refno = this.commonCRMmapper.get("state");
    try {
      this.rootStore.applyTheValue({ commonLoader: true });
      const response = await commonAxios(
        `/crm/verifyAuth`,
        "POST",
        {},
        {
          code,
          refno,
        }
      );
      //if statsCode === 200
      if (
        response.message === "Token exchanged and record updated successfully"
      ) {
        // this.applyTheValue({
        //   isConnectedCrm: crmName,
        // });
         const existing = this.commonCRMmapper.get("isConnectedCrm") || [];
      if (!existing.includes(crmName)) {
        this.applyTheValue({
          isConnectedCrm: [...existing, crmName],
        });
      }
      }
    } catch (error) {
    } finally {
      this.rootStore.applyTheValue({ commonLoader: false });
    }
  };
  restoreFieldMappings(finalData) {
    finalData.forEach(({ columnKey, columnName, crmKey }) => {
      this.setMapping(
        { fields: columnKey, label: columnName }, // Pass as object
        crmKey // This is the selected value
      );
    });
  }
  removeConnectedCrm = (crm) => {
    console.log(crm,"92198220-")
  const existing = this.commonCRMmapper.get("isConnectedCrm") || [];
  const updated = existing.filter((item) => item !== crm);

  this.applyTheValue({
    isConnectedCrm: updated,
  });
};

  handleDisconnect = async (crm) => {
    try {
      this.rootStore.callCommonLoader(true);
      // const crmName = localStorage.getItem("crmName") || "hubspot";
      const response = await commonAxios(
        `/crm/revoke`,
        "GET",
        {},
        {
          crm: crm,
        }
      );
     if (response?.statusCode === 200 || response?.message === "Success") {
      this.removeConnectedCrm(crm);
    }
      
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };

   crmJsonData= async () => {
    try {
      this.rootStore.callCommonLoader(true);
      const response = await commonAxios(
        `/crm/list`,
        "GET",
        {},
        {
        }
      );
      console.log(response,"response123")
      runInAction(()=>{
        this.integrations= response?.data?.data?.crm ?? []
      })
      
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };

  makeDefultCrm=async(crm)=>{
    try {
      this.rootStore.callCommonLoader(true);
      const response = await commonAxios(
        `/crm/default`,
        "POST",
        {},
        {
          crm:crm?? ''
        }
      );
      if(response?.statusCode==200) {
        this.crmJsonData()
         if(this.commonCRMmapper.get('defaultCRM')!== null) {
        this.applyTheValue({
          defaultCRM: null
        })
      }else{
        this.applyTheValue({
          defaultCRM:crm
        })
      }

      }
      
      
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }

  }
  // checkConnection = async (crm) => {
  //   try {
  //     this.rootStore.callCommonLoader(true);
  //     // const crmName = localStorage.getItem("crmName");
  //     const response = await commonAxios(
  //       `/crm/verifyConnected`,
  //       "GET",
  //       {},
  //       {
  //         crm: crm,
  //       }
  //     );
  //     if (
  //       response.message ===
  //       "Connection verified and tokens refreshed successfully"
  //     ) {
  //       this.applyTheValue({
  //         isConnectedCrm: crm,
  //       });
  //       // this.applyTheValue({
  //       //   isConnectedCrm: [...existingCrms, crm],
  //       // });
  //     } else {
  //       this.applyTheValue({
  //         isConnectedCrm: null,
  //       });
  //     }
  //   } catch (error) {
  //   } finally {
  //     this.rootStore.callCommonLoader(false);
  //   }
  // };

  checkConnection = async (crm) => {
  try {
    this.rootStore.callCommonLoader(true);

    const response = await commonAxios(
      `/crm/verifyConnected`,
      "GET",
      {},
      { crm }
    );

    if (
      response.message ===
      "Connection verified and tokens refreshed successfully"
    ) {
      const existing = this.commonCRMmapper.get("isConnectedCrm") || [];
      if (!existing.includes(crm)) {
        this.applyTheValue({
          isConnectedCrm: [...existing, crm],
        });
      }
    } else {
      const existing = this.commonCRMmapper.get("isConnectedCrm") || [];
      this.applyTheValue({
        isConnectedCrm: existing.filter((c) => c !== crm),
      });
    }
  } catch (error) {
    // optional: handle error
  } finally {
    this.rootStore.callCommonLoader(false);
  }
};


  // getEnrichmentFieldApi = async (value) => {
  //   const type =
  //     value === "company" ? "business" : value === "people" ? "contact" : "";
  //   try {
  //     runInAction(() => {
  //       this.rootStore.callCommonLoader(true);
  //     });
  //     const res = await commonAxios(
  //       `/getEnrichKeywords?type=${type}`,
  //       "GET",
  //       {},
  //       {}
  //     );
  //     console.log(res.data.groupByFields,"21903219832323")
  //     runInAction(() => {
  //       this.fieldsList = res.data.list;
  //       this.getOptions(type);
  //     });
  //   } catch (error) {
  //     this.rootStore.callCommonLoader(false);
  //   }
  // };

   getEnrichmentFieldApi = async (value,crm) => {
    const type =
      value === "company" ? "business" : value === "people" ? "contact" : "";
      localStorage.setItem('crmName',crm)
    try {
      runInAction(() => {
        this.rootStore.callCommonLoader(true);
      });
      const res = await commonAxios(
        `/getBundleKeywords?type=${type}`,
        "GET",
        {},
        {}
      );
      runInAction(() => {
        this.fieldsList = res?.data?.keyWordList ?? [];
        this.mandatoryFields= res?.data?.requiredKeys ?? [];
        this.getOptions(type,crm);
      });
    } catch (error) {
      this.rootStore.callCommonLoader(false);
    }
  };

  getOptions = async (value,crm) => {
    try {
      // const user = await getCurrentUser();
      const crmName = localStorage.getItem("crmName");
      const response = await commonAxios(
        `/crm/getColumns`,
        "GET",
        {},
        {
          crm: crm||crmName,
          type: value === "business" ? "companies" : "contact",
        }
      );
      if (response) {
        this.crmlabledata = response?.data?.objectList ?? [];
      }
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };
  handleSavematchedField = async () => {
    try {
      this.rootStore.callCommonLoader(true);
      // const user = await getCurrentUser();
      const crmName = localStorage.getItem("crmName") || 'hubspot';
      const response = await commonAxios(
        `/crm/savefieldMapping`,
        "POST",
        {},
        {
          crm: crmName,
          type:
            this.commonCRMmapper.get("activeTab") === "people"
              ? "contact"
              : "companies",
          fields: this.getPayload(),
          // enrichmentPreference:"enrich",
          enrichmentPreference : this.selectedOption == "Create NewRecords" ? "enrich" : "overwrite"
        }
      );
      //if statsCode === 200
      if (response) {
        showAlertToast({
          type: "success",
          title: "Successful",
          message: "Your field map data is saved successfully.",
        });
        this.selectedOption="Create NewRecords"
      }
    } catch (error) {
      showAlertToast({
          type: "warning",
          title: "Please fill the required fields",
          message: error?.response?.data?.error?.message ?? "",
        });
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };
  restoreFieldMapping = async () => {
    try {
      this.rootStore.callCommonLoader(true);
      // const user = await getCurrentUser();
      const crmName = localStorage.getItem("crmName") || 'hubspot';
      const response = await commonAxios(
        `/crm/getfieldMapping`,
        "GET",
        {},
        {
          crm: crmName,
          type:
            this.commonCRMmapper.get("activeTab") === "people"
              ? "contact"
              : "companies",
        }
      );
      const restoreData = response.finalData;
      if (response) {
        this.restoreFieldMappings(response?.data?.finalData || []);
      }
      restoreData.forEach((item) => {
        const fieldKey = item.columnName;
        const selectedLabel = item.crmKey;
        const fieldExists = this.fieldsList.some(
          (field) => field.value === fieldKey
        );
        const labelExists = this.crmlabledata.some(
          (opt) => opt.value === selectedLabel
        );
        if (fieldExists && labelExists) {
          this.fieldMappings[fieldKey] = selectedLabel;
        }
      });
    } catch (error) {
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };
}
export default CRMStore;
